<template>
  <div>
    <div class="table-operations">
      <a-button @click="showAddDepartments()" :disabled="loading">
        Выбрать отделы
      </a-button>
      <a-button @click="showAddColumn()" :disabled="loading">
        Добавить столбец
      </a-button>
      <a-button @click="showCallsEdit()" :disabled="loading">
        Нормативы звонков
      </a-button>
       <a-button @click="showZoomEdit()" :disabled="loading">
        Масштабирование
      </a-button>
    </div>
    <a-table 
      :columns="columns" 
      :data-source="data" 
      bordered
      :loading="loading"
    >
      <template v-for="col in this.customColumns">
        <span :key="col.dataIndex" :slot="col.dataIndex"
          >{{ col.name}} 
          <a-icon
            type="edit"
            :style="{ color: '#eb2f96', cursor: 'pointer' }"
            @click="showEditModal(col.dataIndex)"
        /></span>
      </template>

      <template
        v-for="col in columns.map((c) => c.dataIndex)"
        :slot="col"
        slot-scope="text, record"
      >
        <div :key="col">
          <a-input
            v-if="record.editable"
            style="margin: -5px 0"
            :value="text"
            @change="(e) => handleChange(e.target.value, record.key, col)"
          />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
          <span v-if="record.editable">
            <a @click="() => save(record.key)">Сохр.</a>
            <a @click="() => cancel(record.key)">Отмена</a>
          </span>
          <span v-else>
            <a :disabled="editingKey !== ''" @click="() => edit(record.key)"
              >Ред.</a
            >
          </span>
        </div>
      </template>
    </a-table>
    <a-modal
      v-model="showColumnsModal"
      :title="modalTitle"
      width="730px"
      centered
      @ok="() => (showColumnsModal = false)"
      :okButtonProps="{ props: { disabled: true} }" 
      :cancelButtonProps="{ props: { disabled: true} }" 
    >
      <row-modal 
        :formType="formType" 
        :baseUrl="baseUrl" 
        :initialData="modalColumn" 
        :statuses="statuses" 
        @statusChange="statusChanged"
        :panelId="panelId"
        :password="password"
        :adminpassword="adminpassword"
      />
    </a-modal>
    <a-modal
      v-model="showDepsModal"
      title="Выберите отделы"
      centered
      @ok="() => (showDepsModal = false)"
      :okButtonProps="{ props: { disabled: true} }" 
      :cancelButtonProps="{ props: { disabled: true} }" 
    >
      <dep-modal 
        :baseUrl="baseUrl" 
        @depsChange="depsChanged"
        :panelId="panelId"
        :password="password"
        :adminpassword="adminpassword"
        :deps="deps"
        :addedDeps="addedDeps"
      /> 
    </a-modal>
    <a-modal
      v-model="showCallsModal"
      title="Норма звонков"
      centered
      @ok="() => (showCallsModal = false)"
      :okButtonProps="{ props: { disabled: true} }" 
      :cancelButtonProps="{ props: { disabled: true} }" 
    >
      <calls-modal 
        :baseUrl="baseUrl" 
        @callsChange="callsChanged"
        :panelId="panelId"
        :password="password"
        :adminpassword="adminpassword"
        :callsSettings="callsSettings"
      /> 
    </a-modal>
    <a-modal
      v-model="showZoomModal"
      title="Норма звонков"
      centered
      @ok="() => (showZoomModal = false)"
      :okButtonProps="{ props: { disabled: true} }" 
      :cancelButtonProps="{ props: { disabled: true} }" 
    >
      <zoom-modal 
        :baseUrl="baseUrl" 
        @zoomChange="zoomChanged"
        :panelId="panelId"
        :password="password"
        :adminpassword="adminpassword"
        :zoomSettings="zoomSettings"
      /> 
    </a-modal>
  </div>
</template>
<script>
import bent from 'bent';
import rowModal from './rowModal';
import depModal from './depModal'
import callsModal from './callsModal'
import zoomModal from './zoomModal'

const defaultColumns = [
  {
    title: 'Менеджер',
    dataIndex: 'name',
    width: '200px',
  }
];

const opColumn = {
  title: '',
  dataIndex: 'operation',
  width: '150px',
  scopedSlots: { customRender: 'operation' },
};


export default {
  props: ['panelId', 'password', 'adminpassword', 'baseUrl'],
  components: {
    rowModal,
    depModal,
    callsModal,
    zoomModal
  },
  data() {
    return {
      formType: 'new',
      modalTitle: null,
      showColumnsModal: false,
      showDepsModal: false,
      showCallsModal: false,
      zoomSettings: {},
      callsSettings: {},
      showZoomModal: false,
      currentRow: {},
      post: {},
      get: {},
      userColumns: [],
      deps: [],
      data: [],
      editingKey: '',
      statuses: [],
      addedDeps: [],
      loading: true,
      initialColumn: {
        _id: null,
        name: null,
        order: null,
        addedStatuses:[],
        type: null,
        nulled: null,
        addedWeekday: null,
        addedMonthDays: [],
        nullTime: null
      },
      modalColumn: {}
    };
  },
  async mounted() {
    this.post = bent(this.baseUrl, 'POST', 'json', 200);
    this.init();
  },
  computed: {
    customColumns() {
      return this.userColumns
        .map((c) => {
          return {
            dataIndex: c._id,
            name: c.name,
            scopedSlots: { customRender: c._id },
            slots: { title: c._id },
          };
        })
        .sort((a, b) => a.order - b.order);
    },
    columns() {
      return [...defaultColumns, ...this.customColumns, opColumn];
    },
  },
  methods: {
    statusChanged() {
      this.showColumnsModal = false
      this.init()
    },
    depsChanged() {
      this.showDepsModal = false;
      this.init()
    },
    callsChanged(settings) {
      this.callsSettings = settings
      this.showCallsModal = false
    },
    zoomChanged(settings) {
      this.zoomSettings = settings
      this.showZoomModal = false
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
        }
      });
    },
    handleScheduleTypeChange(value) {
      console.log({ value });
      console.log({ nulled: this.form.getFieldValue('nulled') });
    },
    async init() {
      this.loading = true
      const colPromise = this.post('getColumns', {
        panelId: this.panelId,
        password: this.password,
        adminpassword: this.adminpassword,
      });
      const callsPromise = this.post('getCallsSettings', {
        panelId: this.panelId,
        password: this.password,
        adminpassword: this.adminpassword,
      })
      const zoomPromise = this.post('getZoomSettings', {
        panelId: this.panelId,
        password: this.password,
        adminpassword: this.adminpassword,
      })
      const depsPromise = this.post('getDepartments', {
        panelId: this.panelId,
        password: this.password,
        adminpassword: this.adminpassword,
      });
      const addedDepsPromise = this.post('getAddedDeps', {
        panelId: this.panelId,
        password: this.password,
        adminpassword: this.adminpassword,
      });
      const statusesPromise = this.post('getStatuses', {
        panelId: this.panelId,
        password: this.password
      })
      const dataPromise = this.post('getData', {
        panelId: this.panelId,
        password: this.password,
        adminpassword: this.adminpassword
      })

      this.userColumns = await colPromise
      this.deps = await depsPromise
      this.callsSettings = await callsPromise
      this.zoomSettings = await zoomPromise
      this.addedDeps = await addedDepsPromise
      this.statuses = await statusesPromise
      this.data = await dataPromise

      this.cacheData = this.data.map((item) => ({ ...item }));
      this.loading = false
    },
    showAddColumn() {
      this.modalTitle = 'Добавление нового столбца';
      this.formType = 'new'
      this.modalColumn = this.initialColumn;
      this.showColumnsModal = true;
    },
    showAddDepartments() {
      this.showDepsModal = true
    },
    showCallsEdit() {
      this.showCallsModal = true
    },
    showZoomEdit() {
      this.showZoomModal = true
    },
    showEditModal(col_id) {
      const col = this.userColumns.find(c => c._id === col_id)
      this.modalColumn = {
        _id: col._id,
        name: col.name,
        order: col.order,
        addedStatuses: col.addedStatuses,
        addedWeekday: col.schedule.addedWeekday,
        type: col.type,
        nulled: col.schedule.nulled,
        addedMonthDays: col.schedule.addedMonthDays,
        nullTime: col.schedule.nullTime
      }
      this.modalTitle = 'Редактирование столбца';
      this.formType = 'edit'

      //this.currentRow = this.initialRow;
      this.showColumnsModal = true;
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(key) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = key;
      if (target) {
        target.editable = true;
        this.data = newData;
      }
    },
    async save(key) {
      const newData = [...this.data];
      const newCacheData = [...this.cacheData];
      const target = newData.filter((item) => key === item.key)[0];
      const targetCache = newCacheData.filter((item) => key === item.key)[0];
      if (target && targetCache) {
        delete target.editable;
        this.data = newData;
        Object.assign(targetCache, target);
        this.cacheData = newCacheData;
        this.loading = true
        await this.post('editData', {
          data: target,
          panelId: this.panelId,
          password: this.password,
          adminpassword: this.adminpassword
        } )
        this.loading = false
      }
      this.editingKey = '';
    },
    cancel(key) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = '';
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter((item) => key === item.key)[0]
        );
        delete target.editable;
        this.data = newData;
      }
    },
  },
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
.table-operations {
  margin-bottom: 16px;
}

.table-operations > button {
  margin-right: 8px;
}

.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}
.dynamic-delete-button:hover {
  color: #777;
}
.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
